import { ENV } from '../constants/environments';

const shouldEnterMaintenanceMode = (): boolean => ENV.maintenanceMode === 'true';

const maintenanceHelpers = {
  shouldEnterMaintenanceMode,
};

export default maintenanceHelpers;
